import { decryptData } from "./cryptoUtils";

export const getToken = (): string | null => {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken");
};

// Utility function to get facility ID
export const getFacilityId = (): string | null => {
  return localStorage.getItem("facilityId") || sessionStorage.getItem("facilityId");
};

// export const getLoginUserData = (): string | null => {
//   return (
//     localStorage.getItem("loginUserData") ||
//     sessionStorage.getItem("loginUserData")
//   );
// };

export const getLoginUserId = (): any => {
  return (
    localStorage.getItem("loginUserId") || sessionStorage.getItem("loginUserId")
  );
};

export const getLoginUserData = (): string | null => {
  const encryptedData = localStorage.getItem("loginUserData") || sessionStorage.getItem("loginUserData");
  if (!encryptedData) return null;

  try {
    const decryptedData = decryptData(encryptedData); // Decrypt first
    if (!decryptedData) return null;
    
    return JSON.parse(decryptedData); // Parse the decrypted JSON string
  } catch (error) {
    console.error("Error decrypting login data:", error);
    return null;
  }
};

// SuperAdmin who also has provider (both-portal) access — eligible to broadcast chat messages
export const canBroadcastMessage = (): boolean => {
  try {
    const parseLoginUserData: any = getLoginUserData();
    const userData = JSON.parse(parseLoginUserData);
    return (
      userData?.roleNames?.includes("SuperAdmin") === true &&
      userData?.customAttributes?.isAdminAccess === "true"
    );
  } catch (error) {
    return false;
  }
};

export const getUserPermission = (): any => {
  const encryptedData = localStorage.getItem("userPermission") || sessionStorage.getItem("userPermission");
  if (!encryptedData) return null;

  try {
    const decryptedData = decryptData(encryptedData);
    if (!decryptedData) return null;
    
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Error decrypting user permission data:", error);
    return null;
  }
};

export const getFacilities = (): any[] => {
  const facilitiesData = localStorage.getItem("facilities") || sessionStorage.getItem("facilities");
  if (!facilitiesData) return [];

  try {
    return JSON.parse(facilitiesData);
  } catch (error) {
    console.error("Error parsing facilities data:", error);
    return [];
  }
};

export const shouldShowSwitchToProvider = (): boolean => {
  const userDataString = getLoginUserData();
  const facilities = getFacilities();
  
  if (!userDataString || !facilities) return false;
  
  try {
    const userData = JSON.parse(userDataString);
    
    const isAdminAccess = userData?.customAttributes?.isAdminAccess;
    const hasFacilities = facilities && facilities.length > 0;
    
    return isAdminAccess === "true" && hasFacilities;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return false;
  }
};

